module.exports = __webpack_public_path__ + "th.5f831e47.svg";